import RelatedContentBlock from "./RelatedContentBlock";

export default RelatedContentBlock;
